import QuinielazoService from "@/services/QuinielazoService";

export const namespaced = true;

export const state = {
	torneos: [],
	torneo: {}
};

export const mutations = {
	ADD_TORNEO(state, torneo) {
		state.torneos.push(torneo);
	},
	UPDATE_TORNEO(state, torneo){
		for (var t in state.torneos) {
			if (state.torneos[t].id == torneo.id) {
				this._vm.$set(state.torneos,t,torneo)
				break;
			}
		}
	},
	SET_TORNEOS(state, torneos) {
		state.torneos = torneos;
	},
	SET_TORNEO(state, torneo) {
		state.torneo = torneo;
	}
};

export const actions = {
	fetchTorneos({ commit, dispatch }) {
		QuinielazoService.getTorneos()
		.then(resp => {
			commit("SET_TORNEOS", resp.data);
		})
		.catch(err => {
			const notification = {
				type: "error",
				message: "Hubo un problema leyendo los torneos: " + err.message
			};
			dispatch("notification/add", notification, { root: true });
    });
	},
	saveTorneo({ commit, rootState, dispatch }, torneo) {
		console.log("Usuario creando Liga es " + rootState.user.user.name);
		if (torneo.id != undefined) {
			return QuinielazoService.updateTorneo(torneo)
			.then(() => {
				commit('UPDATE_TORNEO', torneo)
				dispatch("notification/add", {message: 'Se guardo el torneo :)'}, { root: true });
				//Si se agrego logo
				if (torneo.logo) {
					console.log(torneo.logo)
					dispatch('postLogo',{id: torneo.id, logo: torneo.logo})
				}
			})
			.catch(err => {
				dispatch("notification/add", {
					type: 'error',
					message: err.message
				}, { root: true });
			})
		}else{
			return QuinielazoService.postTorneo(torneo)
			.then(resp => {
				console.log(resp);
				commit("ADD_TORNEO", resp.data);
				const notification = {
					type: "success",
					message: "Se guardo el torneo"
				};
				dispatch("notification/add", notification, { root: true });

				//Si se agrego logo
				if (torneo.logo) {
					console.log(torneo.logo)
					dispatch('postLogo',{id: resp.data.id, logo: torneo.logo})
				}
			})
			.catch(err => {
				const notification = {
					type: "error",
					message: "Hubo un problema al crear el torneo " + err.message
				};
				dispatch("notification/add", notification, { root: true });
			});
		}
	},
	fetchTorneo({ commit, getters, dispatch }, id) {
		var torneo = getters.getTorneoById(id);

		if (torneo) {
			commit("SET_TORNEO", torneo);
		} else {
			QuinielazoService.getTorneo(id)
			.then(resp => {
				commit("SET_TORNEO", resp.data);
			})
			.catch(error => {
				const notification = {
					type: "error",
					message: "Hubo un problema al crear el torneo " + error.message
				};
				dispatch("notification/add", notification, { root: true });
			});
		}
	},
	postLogo({ dispatch }, data){
		console.log(data)
		let fd = new FormData();
		fd.append('id',data.id)
		fd.append('logo',data.logo)
		console.log(fd)

		return QuinielazoService.updateTorneoImg(data.id, fd)
		.then(() => {
			console.log('se guardo el logo :P')
		})
		.catch(err => {
			console.log(err,err.response)
			dispatch("notification/add", {
				type: 'error',
				message: 'No se pudo guardar el logo' + err.message
			}, { root: true });						
		})
	}
};

export const getters = {
	getTorneoById: state => id => {
		return state.torneos.find(torneo => torneo.id === id);
	}
};
